import { h } from "preact";
import { useState } from "preact/hooks";

let timeout = null;

export default function MiniCartQuotes({ quotesUrl }) {
  return (
    <div className="mini-cart__quotes">
      <button
        type="button"
        className="button button--black-outline button--full"
        onClick={() => {
          document.dispatchEvent(new CustomEvent("mini-cart:close"));
          document.dispatchEvent(new CustomEvent("quote-modal:open"));
        }}
      >
        {window.localeStrings.cart.save_quote}
      </button>
      <a href={quotesUrl} className="link link--black">
        {window.localeStrings.cart.view_quotes}
      </a>
    </div>
  );
}
